"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomerTypeImages = void 0;

var _styles = require("./styles");

var _Cadena = _interopRequireDefault(require("../../../assets/images/providerAndCadena/Cadena.svg"));

var _Proveedor = _interopRequireDefault(require("../../../assets/images/providerAndCadena/Proveedor.svg"));

var _jsxRuntime = require("react/jsx-runtime");

var CustomerTypeImages = function CustomerTypeImages(_ref) {
  var _ref$imageType = _ref.imageType,
      imageType = _ref$imageType === void 0 ? "retailer" : _ref$imageType;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
    imageType: imageType,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      src: imageType === "retailer" ? _Cadena.default : _Proveedor.default,
      alt: imageType === "retailer" ? "Cadena" : "Proveedor"
    })
  }, "image-".concat(imageType));
};

exports.CustomerTypeImages = CustomerTypeImages;